// extracted by mini-css-extract-plugin
export var callCard = "_rh-0";
export var callMessageButton = "_rh-1";
export var helpIcon = "_rh-3";
export var helpIconContainer = "_rh-4";
export var verticalDivider = "_rh-2";